import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="border-b border-line bg-canvasAlt" data-id="element-169" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-6 text-center sm:px-5" data-id="element-170" data-mp="3b01g5as6vss1">
        <h2 id="testimonios" className="font-display text-base font-extrabold uppercase leading-tight text-ink sm:text-xl" data-id="element-171" data-mp="36z94kavuhbsl">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-ink-muted" data-id="element-172" data-mp="2x1kzar0m4lw6">
          De no saber por dónde comenzar a comprender cómo funciona un sistema
          de acceso.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-173" data-mp="v8591v8ft91q">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-line bg-surface p-3 text-left" data-id="element-174" data-mp="qbn7t5cbfsu5" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-175" data-mp="m6cgbvme6l14">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={11} className="fill-accent text-accent" data-id="element-176" data-mp="c6llfstx640i" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1.5 text-[0.8rem] leading-snug text-ink" data-id="element-177" data-mp="14v9c63xftllg">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-2" data-id="element-178" data-mp="q5l6yrm4y2sg">
                <p className="font-display text-[0.75rem] font-extrabold uppercase text-cyan" data-id="element-179" data-mp="q4s9yiczarni">
                  {t.author}
                </p>
                <p className="text-[0.68rem] leading-snug text-ink-subtle" data-id="element-180" data-mp="1iu90tbkya0hm">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.15} className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-accent/50 bg-accent-soft p-3" data-id="element-181" data-mp="1xi9257p37bch">
            <CtaButton href={OFFER_ANCHOR} data-id="element-182" data-mp="1ogjaq1v7gcep">
              🚀 Sí, quiero comenzar ahora
            </CtaButton>
            <p className="mt-1.5 text-[0.68rem] font-semibold text-ink-muted" data-id="element-183" data-mp="1jh6ggw208323">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}